import React, { useContext, useEffect, useState } from "react";
const ClientPrincipalContext = React.createContext({
    loaded: false,
    clientPrincipal: null,
});
const ClientPrincipalContextProvider = ({ children, }) => {
    const [clientPrincipal, setClientPrincipal,] = useState(null);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        const run = async () => {
            try {
                const res = await fetch("/.auth/me");
                const json = await res.json();
                if (json.clientPrincipal) {
                    setClientPrincipal(json.clientPrincipal);
                }
            }
            catch (e) {
                if (window.location.hostname === "localhost") {
                    console.warn("Can't access the auth endpoint. For local development, please use the Static Web Apps CLI to emulate authentication: https://github.com/azure/static-web-apps-cli");
                }
                else {
                    console.error(`Failed to unpack JSON.`, e);
                }
            }
            setLoaded(true);
        };
        run();
    }, []);
    return (React.createElement(ClientPrincipalContext.Provider, { value: { loaded, clientPrincipal } }, children));
};
const useClientPrincipal = () => useContext(ClientPrincipalContext);
export { ClientPrincipalContextProvider, useClientPrincipal };
//# sourceMappingURL=ClientPrincipalContext.js.map